import $ from "jquery";
import prestashop from "prestashop";
import Filters from "./components/filters/Filters";
import getQueryParameters from "./components/urlparser";
function updateProductListDOM(data) {
  console.log(data.rendered_facets);
  console.log(data.sort_orders);
  $("#search_filters").replaceWith(
    '<div id="search_filters">' + data.rendered_facets + "</div>"
  );
  $("#js-product-list-top").replaceWith(data.rendered_products_top);
  $("#js-product-list").replaceWith(data.rendered_products);
  $("#js-product-list-bottom").replaceWith(data.rendered_products_bottom);
  if (data.rendered_products_header) {
    $("#js-product-list-header").replaceWith(data.rendered_products_header);
  }
  prestashop.emit("updatedProductList", data);
}
$(() => {
  const filters = new Filters();
  prestashop.on("updateProductList", (data) => {
    updateProductListDOM(data);
    window.scrollTo(0, 0);
  });
  prestashop.on("updatedProductList", () => {
    prestashop.pageLazyLoad.update();
  });
});
function testUrl() {
  const $el = $(this);
  const nextEncodedFacetsURL = window.location.href;
  const urlsSplitted = nextEncodedFacetsURL.split("?");
  let queryParams = [];
  if (urlsSplitted.length > 1) {
    queryParams = getQueryParameters(urlsSplitted[1]);
  }
  let found = false;
  queryParams.forEach((query) => {
    if (query.name === "q") {
      found = true;
    }
  });
  if (!found) {
    queryParams.push({ name: "q", value: "" });
  }
  queryParams.forEach((query) => {
    if (query.name === "q") {
      query.value += [
        query.value.length > 0 ? "/" : ""
      ].join("");
    }
  });
  console.log(queryParams);
}
